import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative pt-32 pb-20 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-[#ede9fe] to-white"></div>
      <div className="absolute inset-0 bg-black/20"></div>
      
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/55c55fb16f238eab390aec596945a10e.jpg"
          alt="Abstract digital network background representing AI-powered SEO analysis and search engine optimization technology"
          className="w-full h-full object-cover object-top"
        />
      </div>

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <div className="inline-block px-4 py-2 bg-[#4f3af6]/90 rounded-full text-sm font-medium mb-6">
              Proprietary AI-Powered  Analysis
            </div>
            <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight text-[#4f3af6]">
              The AI SEO Analysis Tool<br />
              That Dominates Search<br />
              Rankings &amp; Grows Traffic.
            </h1>
            <p className="text-lg mb-8 text-[#4f3af6]/90 leading-relaxed">
              SEOPower analyzes your web pages in real-time and provides business driven, actionable optimization opportunities to boost your search engine visibility.
            </p>
            <div className="flex flex-wrap gap-4">
              <Link
                to="/purchase"
                className="px-8 py-3 bg-[#4f3af6] text-white rounded-full font-medium hover:bg-[#4f3af6]/90 transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                Try SEOPower Today
                <i className="ri-arrow-right-line"></i>
              </Link>
              <button className="px-8 py-3 bg-transparent border-2 border-white text-white rounded-full font-medium hover:bg-white hover:text-[#4f3af6] transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer">
                <i className="ri-play-circle-line"></i>
                Watch Demo
              </button>
            </div>
          </div>

          <div className="relative">
            <div className="relative z-10">
              <img
                src="https://static.readdy.ai/image/c35406c68f4851f7123e42c3a05fcb72/71df65b15bb9cb9f41100eae645eaa5b.jpeg"
                alt="SEOPower AI SEO analysis tool dashboard showing real-time keyword insights, page optimization scores, and search ranking data"
                className="w-full h-auto rounded-2xl shadow-2xl transform hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="absolute -top-8 -right-8 w-64 h-64 bg-[#4f3af6]/20 rounded-full blur-3xl"></div>
            <div className="absolute -bottom-8 -left-8 w-64 h-64 bg-[#FF6B35]/20 rounded-full blur-3xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
